





























import {Component, Prop, Vue, Watch, Ref} from 'vue-property-decorator'

@Component
export default class DaumPostcode extends Vue {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 'gray-900', type: String}) borderStyle: string
  @Prop({default: true, type: Boolean}) visibleCloseButton: boolean

  @Ref('postcodeWrap') readonly postcodeWrap: any

  get styles(): object {
    return {
      display: this.value ? 'block' : 'none',
    }
  }

  get classes(): string[] {
    return [`k-border-${this.borderStyle}`]
  }

  @Watch('value', {immediate: true})
  __value(value) {
    if(value) {
      this.$nextTick(() => {
        this.initDaumPostcode()
      })
    }
  }

  foldDaumPostcode() {
    this.$emit('input', false)
  }

  initDaumPostcode() {
    // 현재 scroll 위치를 저장해놓는다.
    const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop)
    const elementWrap: any = this.postcodeWrap

    const daum = window['daum']
    new daum.Postcode({
      oncomplete: (data) => {

        let userSelectValue = ''
        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if(data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
          userSelectValue = data.roadAddress
        } else { // 사용자가 지번 주소를 선택했을 경우(J)
          userSelectValue = data.jibunAddress
        }

        // iframe을 넣은 element를 안보이게 한다.
        this.$emit('select-address', {data, userSelectValue})
        this.$emit('input', false)

        // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
        document.body.scrollTop = currentScroll
      },
      // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
      onresize: (size) => {
        elementWrap.style.height = size.height+'px'
      },
      width : '100%',
      height : '100%',
    }).embed(elementWrap)

  }
}
